<template lang="pug">
  v-card(
    :disabled="isForbidden"
    flat
    v-bind="$attrs"
    height="88"
  ).sdo-card.card-hover
    v-list-item.fill-height.pr-2.my-0
      v-list-item-action.mr-4(v-if="unit.hasConsultationMessages")
        tooltip-wrap(
            text="Есть ответы преподавателя"
          )
            v-avatar(
              color="error"
              size="40"
            )
              v-icon(color="white") mdi-message
      v-list-item-avatar.mr-4(
        width="20"
        size="38"
        :color="getColorUnit(unit)"
        :value="unit.progress"
      )
        .caption.black--text {{ unit.lessonsPassed.length }}/{{ unit.lessons.length }}
      v-list-item-content

        span: .text-body-1.card-title {{ unit.title }}
        .text-caption {{ unit.lessons.length }} уроков

      v-list-item-action(v-if="isForbidden")
        tooltip-wrap(text="Тема закрыта")
          v-icon(large) mdi-lock
      v-list-item-action.ml-2(v-else)
        v-icon(color="primary" size="20") mdi-arrow-right
</template>

<script>
export default {
  props: {
    unit: { type: Object, required: true },
    preWrap: { type: Boolean, default: false },
    idx: { type: Number, default: null },
    isForbidden: { type: Boolean, default: false },
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
  },
  methods: {
    getColorUnit(unit) {
      if (unit.lessons.length) {
        const count = this.getPassedLessons(unit).length;
        if (count > 0) {
          return unit.user_passed ? 'success' : 'warning lighten-2';
        }
        return 'grey lighten-2';
      }
      return unit.user_passed ? 'success' : 'grey lighten-2';
    },
    getPassedLessons(unit) {
      return unit.lessons.filter((l) => l.user_passed);
    },
    isUnitForbidden(idx) {
      return (
        // не рандомный порядок
        !this.course.random_order
        // не первая тема
        && idx !== 0
        // в предыдущем уроке нет непройденного
        && this.courseUnits[idx - 1].lessons.find((l) => l.user_passed === false)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sdo-card {
  overflow: initial;
}
.unit-progress {
  position: absolute;
  top: -20px;
  left: 20px;
}

.warning-text {
  color:  black;
}
.success-text {
  color:  white;
  caret-color: white;
}
.card-title {
  overflow: hidden;
  display: flex;
  white-space: initial;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
}
</style>
